import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL, assetUrl } from "../config/api";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
} from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../include/Header";
import CustomBreadcrumb from "../include/Breadcrumb";

function EditProduct() {

  // ===========================
  // 🧠 URL SE PRODUCT ID LENA
  // ===========================
  const { id } = useParams();

  // ===========================
  // 🧠 PAGE REDIRECT (NAVIGATION)
  // ===========================
  const navigate = useNavigate();

  // ===========================
  // 🧠 FORM STATE (PRODUCT DATA)
  // ===========================
  const [formData, setFormData] = useState({
    name: "",        // product name
    description: "", // product description
    price: "",       // product price
    image: null,     // new uploaded image
    oldImage: "",    // existing image
  });

  // ===========================
  // 📥 SINGLE PRODUCT FETCH
  // ===========================
  const getProduct = async () => {
    try {

      const res = await axios.get(
        `${API_URL}/product/${id}`
      );

      // fill form with API data
      setFormData({
        name: res.data.product.name,
        description: res.data.product.description,
        price: res.data.product.price,
        image: null, // new image blank
        oldImage: res.data.product.file_path,
      });

    } catch (error) {
      console.log(error);
      alert("Product Not Found");
    }
  };

  // page load pe single product fetch
  useEffect(() => {
    getProduct();
  }, []);

  // ===========================
  // ✍️ INPUT CHANGE HANDLER
  // ===========================
  const handleChange = (e) => {

    // agar image select kiya
    if (e.target.name === "image") {

      setFormData({
        ...formData,
        image: e.target.files[0],
      });

    } else {

      // normal input (name, price, description)
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  // ===========================
  // 🚀 UPDATE PRODUCT API
  // ===========================
  const handleSubmit = async (e) => {

    e.preventDefault(); // page reload stop

    const data = new FormData();

    // text data add
    data.append("name", formData.name);
    data.append("description", formData.description);
    data.append("price", formData.price);

    // image only if new selected
    if (formData.image) {
      data.append("image", formData.image);
    }

    try {

      const res = await axios.post(
        `${API_URL}/update-product/${id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(res.data.message);

      // update ke baad listing page pe bhej do
      navigate("/updateproduct");

    } catch (error) {

      console.log(error.response?.data);
      alert("Update Failed");
    }
  };

  // ===========================
  // 🖥️ UI START
  // ===========================
  return (
    <>
      <Header />

      <div className="ved">

        <Container className="my-5">

          <CustomBreadcrumb title="Edit Product" />

          <Row className="shadow-lg p-4 rounded bg-white">

            {/* ===========================
                🖼️ LEFT IMAGE PREVIEW
            =========================== */}
            <Col md={6}>

              <Image
                src={
                  formData.image
                    ? URL.createObjectURL(formData.image) // new image preview
                    : assetUrl(formData.oldImage)
                }
                fluid
                rounded
              />

            </Col>

            {/* ===========================
                🧾 RIGHT FORM
            =========================== */}
            <Col md={6}>

              <h2 className="mb-4">
                Edit Product
              </h2>

              <Form onSubmit={handleSubmit}>

                {/* NAME */}
                <Form.Group className="mb-3">

                  <Form.Label>Product Name</Form.Label>

                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />

                </Form.Group>

                {/* DESCRIPTION */}
                <Form.Group className="mb-3">

                  <Form.Label>Description</Form.Label>

                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  />

                </Form.Group>

                {/* PRICE */}
                <Form.Group className="mb-3">

                  <Form.Label>Price</Form.Label>

                  <Form.Control
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleChange}
                    required
                  />

                </Form.Group>

                {/* IMAGE */}
                <Form.Group className="mb-4">

                  <Form.Label>Change Image</Form.Label>

                  <Form.Control
                    type="file"
                    name="image"
                    onChange={handleChange}
                  />

                </Form.Group>

                {/* SUBMIT BUTTON */}
                <Button
                  type="submit"
                  variant="warning"
                  className="w-100"
                >
                  Update Product
                </Button>

              </Form>

            </Col>

          </Row>

        </Container>

      </div>
    </>
  );
}

export default EditProduct;